<template>
  <div
    class="fb-messenger-checkbox "
    :class="{ 'alerts-border': displaeErr }"
    :origin="getDomain"
    :page_id="getFbPgId"
    :messenger_app_id="getMessengerId"
    :user_ref="getUsrRef"
    allow_login="true"
    :size="isMobile"
    skin="light"
    :ref="instanceId + '|' + cartId"   
  >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { initFbSdk } from "@/lib/FacebookSdk";
import Vue from "vue";
import store from "@/store";
import uniqid from "uniqid";

export default {
  name: "MessengerCheckbox",
  components: {},
  data() {
    return {
      instanceId: "123",
      cartId: "",
    };
  }, 

  computed: {
    ...mapGetters(["getWidgetsState", "getFbDetails", "getInstanceId"]),
    isCenter() {
      return this.getWidgetsState.subscribe_type == "subscribe"
        ? "false"
        : "true";
    },
    getDomain() {
      return `https://${location.host}/`;
    },
    getUsrRef() {
      return "chk-" + uniqid();
    },
    getDataRef() {
      return this.getInstanceId;
    },
    getMessengerId() {
      return this.getFbDetails.messenger_app_id;
    },
    getFbPgId() {
      return this.getFbDetails.page_id;
    },

    getDivClass() {
      return this.getFbDetails.div_class;
    },
    getRef() {
      return this.instanceId + "|" + this.cartId;
    },
    displaeErr() {
      return this.$store.getters.getErrFlashFB;
    },
    isMobile() {
      if (screen.width <= 900) {
        return "medium";
      } else {
        return "xlarge";
      }
    },
  },
  beforeCreate() { 
    
    initFbSdk(Vue, process.env.VUE_APP_FACEBOOK_CLIENT_ID, store).then(() => {        
      this.instanceId = document.querySelector("widget-view").instance_id;
      this.cartId = document.querySelector("widget-view").cart_id;      
      this.$store.dispatch(
        "setInstanceId",
        this.instanceId + "|" + this.cartId
      );
   
    });
  },  
};
</script>

<style scoped>

</style>
<style>
.fb-messenger-checkbox{
  width: 200px !important;
}
.fb-messenger-checkbox span{
  width: 199px !important;
}
@media (max-width: 900px) {
  .fb-messenger-checkbox{
    margin-left: 35% !important;
  }
  .fb-messenger-checkbox span{
     width: 100%  !important;
     height: 55px !important;
  }
 
}
@media (max-width: 799px) {
  .fb-messenger-checkbox{
    margin-left: -5% !important;
  }
}
@media (max-width: 435px) {
  .fb-messenger-checkbox{
    width: 200px !important;
  }
}

@media (max-width: 325px) {
  .fb-messenger-checkbox{
    width: 161px !important;
  }
}

@media (max-width: 300px) {
  .fb-messenger-checkbox{
    width: 180px !important;
  }
}

@keyframes blink {
  50% {
    border-color: #fff;
  }
}
</style>
